export const onChangeHtmlLanguage = (language: string): void => {
  if (typeof window !== 'undefined') {
    document.documentElement.setAttribute('lang', language);
  }
};
